import { isArray } from "lodash";
import { Navigate, Route, Routes } from "react-router-dom";

export default function LayoutRoutes({ routes = [], defaultPath, children, conditions, componentParams }) {
	const defaultRoute = routes.find((route) => route.default);

	return (
		<div className="xl:col-span-7 col-span-6 overflow-auto h-[calc(100%-153.59px)] pb-28">
			<Routes>
				{routes.map((tab) => {
					if (!tab.component) return null;
					if (!tab.link) return null;
					const show = tab?.show?.(conditions);

					if (typeof tab?.show !== "undefined" && !show) return null;
					const componentArray = isArray(tab.component) ? tab.component : [tab.component];
					return (
						<Route
							key={tab.link}
							path={tab.link}
							element={
								<>
									{componentArray.map((Component, index) => (
										<>
											<Component
												{...{
													...componentParams,
													...tab.componentParams,
													key: index,
													index
												}}
											/>
											<div className="clearfix pt-28" />
										</>
									))}
								</>
							}
						/>
					);
				})}
				{defaultRoute ? (
					<Route
						path="*"
						element={
							<Navigate
								to={`${defaultPath}${defaultRoute.link}`}
								replace
							/>
						}
					/>
				) : null}
				{children}
			</Routes>
		</div>
	);
}
